import { useState } from 'react';
import { GenericModal, OrderListComponent } from 'app/shared/components';
import { useService } from 'app/shared/hooks';
import { editSecao } from 'app/services/serviceCategoria';
import toastr from 'toastr';

const OrderSecoesModal = ({ open, onClose, secoes, onSuccess }) => {
  const [orderedSecoes, setOrderedSecoes] = useState();
  const { request: requestUpdateSecao, response } = useService(editSecao);

  const handleOnChange = (orderItems) => {
    const orderItemsModified = orderItems.map((item, index) => ({
      id: item.id,
      ordem: index + 1,
    }));

    const itensModificados = orderItemsModified.filter((modifiedItem) => {
      const originalItem = secoes.find((item) => item.id === modifiedItem.id);
      return Number(originalItem.ordem) !== Number(modifiedItem.ordem);
    });

    setOrderedSecoes(itensModificados);
  };

  const onSubmit = () => {
    const promises = orderedSecoes.map((item) =>
      requestUpdateSecao({ id: item.id, ordem: item.ordem }),
    );

    Promise.all(promises)
      .then(() => {
        toastr.success('Seções reordenadas com sucesso');
        onSuccess();
        onClose();
      })
      .catch(() => {
        toastr.error('Erro ao reordenar seções');
      });
  };

  return (
    <GenericModal
      open={open}
      title="Ordenar seções"
      preventCloseClickOutside
      hasCloseIcon={false}
      size="sm"
      actions={[
        {
          color: 'default',
          onClick: onClose,
          label: 'CANCELAR',
        },
        {
          label: 'CONFIRMAR',
          loading: response.loading,
          onClick: onSubmit,
        },
      ]}
    >
      <OrderListComponent items={secoes} onChange={handleOnChange} />
    </GenericModal>
  );
};

export default OrderSecoesModal;
